module.exports = __webpack_public_path__ + "static/media/file-png.1e30a848.svg";